export default __webpack_public_path__ + "static/media/en.44ba8ec0.md";